import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { QsHelper } from '../../../../helpers';

import QuickFocus from './QuickFocus';
import QuickHealth from './QuickHealth';
import NoticesPanel from './NoticesPanel';

import { CloseIcon, RoadIcon } from '../../../../common/icons';

import './ClientDetail.css';
import TripPanel from './TripPanel';
import { authStore } from '../../../../stores';

const serviceLevelsWithLimitedFeatures = ['light-a'];

@withRouter
@inject('translationsStore', 'noticesStore', 'authStore')
@observer
export default class ClientDetail extends Component {
  goToTab = (tab) => () => {
    const { history, location } = this.props;
    history.push(`${location.pathname}?tab=${tab}`);
  };

  render() {
    const { translationsStore, car } = this.props;
    const modalInLocationValue = new QsHelper(this.props.location.search).get(
      'modal'
    );

    let leadId = '';
    if (car && car.leads && car.leads.length > 0) {
      leadId = car.leads[0].id;
    }

    return (
      <div className='ClientDetail' style={this.props.style}>
        <div className='top'>
          <div className='left'>
            <div onClick={this.props.back} className='closeIcon'>
              <CloseIcon />
            </div>
            <div>
              <div className='bold'>{(car || {}).makeModel}</div>
              <div>{(car || {}).plate}</div>
            </div>
          </div>
          {authStore.isServiceManager && (
            <div className='left'>
              <div className='bold'>
                {translationsStore.translate('clientdetail.leadId')} {leadId}
              </div>
            </div>
          )}
          <div className='tabs'>
            <div>
              {!authStore.isServiceManager && (
                <div
                  className={`tab button ${
                    this.props.currentTab === 'trip' ? 'selected' : ''
                  }`}
                  onClick={this.goToTab('trip')}
                >
                  <RoadIcon />
                  <div>
                    {translationsStore.translate('clientdetail.tabs.4')}
                  </div>
                </div>
              )}
            </div>
            <div>
              {!authStore.isServiceManager && (
                <div
                  className={`tab ${
                    this.props.currentTab === 'notice' ? 'selected' : ''
                  }`}
                  onClick={this.goToTab('notice')}
                >
                  <div>
                    {translationsStore.translate('clientdetail.tabs.1')}
                  </div>
                </div>
              )}
              <div
                className={`tab ${
                  this.props.currentTab === 'focus' ? 'selected' : ''
                }`}
                onClick={this.goToTab('focus')}
              >
                <div>{translationsStore.translate('clientdetail.tabs.2')}</div>
              </div>
              {((car &&
                car.serviceLevel &&
                !serviceLevelsWithLimitedFeatures.includes(car.serviceLevel)) ||
                (car && car.connectedCarMaintenanceStatus === 'active')) && (
                <div
                  className={`tab ${
                    this.props.currentTab === 'health' ? 'selected' : ''
                  }`}
                  onClick={this.goToTab('health')}
                >
                  <div>
                    {translationsStore.translate('clientdetail.tabs.3')}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {this.props.currentTab === 'focus' && (
          <QuickFocus
            car={car}
            carAddress={this.props.carAddress}
            additionalCarAddresses={this.props.additionalCarAddresses}
            modal={modalInLocationValue}
          />
        )}
        {this.props.currentTab === 'health' && <QuickHealth car={car} />}
        {this.props.currentTab === 'trip' && <TripPanel car={car} />}
        {this.props.currentTab === 'notice' && <NoticesPanel car={car} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/ClientDetail.js